export const ZIndex = {
  rowOverlay: 100,
  navBar: 1000,
  dropdown: 2000,
  sidePanel: 3000,
  modalOverlay: 4000,
  toast: 5000,
} as const;
